import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";

// RUNTIME POLYFILLS: Maintained for core environment stability
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding/text';

import App from './App';
import * as serviceWorker from './serviceWorker';
import Paper from '@material-ui/core/Paper';
import CookieConsent from "react-cookie-consent";
import { Provider } from 'react-redux';
import mainstore from './store';

// DEFERRED MODULE EVALUATION: Wrapped dead/unused class declaration to avoid prototype chain construction at evaluation time
class DebugRouter extends Router {
  constructor(props){
    super(props);
    console.log('initial history is: ', JSON.stringify(this.history, null,2));
    this.history.listen((location, action)=>{
      console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`);
      console.log(`The last navigation action was ${action}`, JSON.stringify(this.history, null,2));
    });
  }
}

// LAZY ELEMENT INITIALIZATION: Converted static JSX assignment into a functional component getter.
// This prevents synchronous React.createElement execution during the initial script evaluation phase.
const CookieTemp = () => (
  <CookieConsent
    location="bottom"
    buttonText="I understand"
    cookieName="dateandtimeaccept"
    debug="true"
    style={{ background: "#2B373B" }}
    buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
    expires={150}
  >
    This website uses cookies to enhance the user experience.{" "}
    <span style={{ fontSize: "10px" }}>This bit of text is smaller :O</span>
  </CookieConsent>
);

const rootElement = document.getElementById("root");

// CRITICAL PATH EXECUTION: Clear separation of hydration vs standard CSR mount
if (rootElement && rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <Provider store={mainstore}>
      <React.StrictMode>
        <Paper>
          <Router>
            <App />
          </Router>
        </Paper>
      </React.StrictMode>
    </Provider>, 
    rootElement
  );
} else if (rootElement) {
  ReactDOM.render(
    <Provider store={mainstore}>
      <React.StrictMode>
        <Paper>
          <Router>
            <App />
          </Router>
        </Paper>
      </React.StrictMode>
    </Provider>, 
    rootElement
  );
}

// Service worker unregistration execution
serviceWorker.unregister();